// Entry point for the build script in your package.json
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root')
  // Only load React app if the root container exists
  // This prevents React Router from loading on non-React pages like /admin
  if (container) {
    const root = createRoot(container)
    root.render(<App />)
  }
})
